import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import Axios from "../apis/axios";
import { NodeId } from "components/NodeId";
import { produce } from "immer";

const createBackupSlice = (set: (data: any) => void, get: () => any) => ({
  getBackups: {},

  createBackup: async (payload: any) => {
    // Ensure that payload and payload.image are initialized
    if (!payload) {
      payload = {};
    }

    if (!payload.image) {
      payload.image = {};
    }

    let filesToUpload;

    const attachment = payload.image[0].attachment;

    attachment.nodeid = payload.nodeid;

    let fileToUpload = _.cloneDeep(attachment);
    fileToUpload.property = "file";
    filesToUpload = [fileToUpload];
    const commandObjects: any[] = [];
    delete payload.image;
    const backupCommandObject = {
      parentNodeIds: [payload.equipmentNodeId],
      filesToUpload: filesToUpload,
      nodeId: payload.nodeid,
      payload: payload,
      type: "create",
      task: "processCreateBackupCommand",
    };
    commandObjects.push(backupCommandObject);

    const promises = await get().enqueueCommands(commandObjects);

    return promises;
  },

  processCreateBackupCommand: async (commandObject: any) => {
    delete commandObject.filesToUpload[0].uploadInfo.url;
    commandObject.payload.backupfile =
      commandObject.filesToUpload[0].uploadInfo;
    try {

      const response = await Axios.post(
        "api/v1/backups",
        commandObject.payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000,
        }
      );

      if (response && response?.status === 200) {
        return response.data;
      } else {
        throw new Error();
      }
    } catch (error) {
      
      throw new Error(String(error));
    }
  },

  getAllBackups: async (nodeId: string) => {
    try {
      if (get().isAuthUser === true) {
        if (nodeId == undefined) {
          return;
        }
        const encodedReportNodeId = encodeURIComponent(nodeId);
        const response = await Axios.get(
          `api/v1/backups?equipmentnodeid=${encodedReportNodeId}`,
          {
            headers: {
              "Content-Type": "application/json",
             
            },
          }
        );

        if (response && response?.status == 200) {
          set(
            produce((state: any) => {
              state.getBackups = response.data;
            })
          );
          // Return the response data after updating the state
          return response.data;
        } else {
          throw new Error();
        }
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },

  deleteBackupConfiguration: async (equipmentsNodeId: any, nodeId: any) => {
    let payload = {
      equipmentsNodeId: equipmentsNodeId,
      nodeId: nodeId,
    };
    const deleteCommandObject = {
      parentNodeIds: payload.equipmentsNodeId,
      nodeId: payload.nodeId,
      payload: payload,
      type: "delete",
      task: "processDeleteBackupCommand",
    };
    let promises = get().enqueueCommands([deleteCommandObject]);

    return promises;
  },

  processDeleteBackupCommand: async (commandObject: any) => {
    try {
      if (commandObject.payload.nodeId == undefined) {
        return;
      }

      const encodedReportNodeId = encodeURIComponent(
        commandObject.payload.nodeId || ""
      );
      const response = await Axios.delete(
        "api/v1/backups/" + encodedReportNodeId,
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000,
        }
      );

      if (response && response?.status === 200) {
        return;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },
});

export default createBackupSlice;
